module.exports = __webpack_public_path__ + "static/media/icon-phone.3b44c1ae.svg";